import { useEffect, useLayoutEffect, useState, useRef} from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../common/commonUtil";
import { apiKeyCheck, detailConditionApi, GetGolfPlanDetail, golfReservationCancel, versionGetApi } from "../../const";
import { useRtoaster } from "../../hooks/useRtoaster";
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { Label } from '../atoms/label';
import './../../resources/css/reservationConfirm/reservationConfirm.css';
import { GolfFooterContainer } from "./golfFooterContainer";

const GolfBookingConfirmContainer = (props) => {
    const {
        toUserInputInfo,
        setToUserInputInfo,
        reserveInfo,
        setReserveInfo,
        reserveCancelInfo,
        setReserveGolfCancelInfo,
        login,
        onChange,
        setReserveType,
        onClickOpenCalendarWindow,
        checkIn,
        checkOut,
        setReserveCheckInfo,
        reserveCheckInfo,
        changeReserveNo,
        setPlan,
        setCourseNames,
        onClickOpenCancelPopupWindow,
        addTeeTimeList,
        addInputPlayer,
        setGolfLocation,
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const processing = useRef(false);

    // プロパティ一覧
    const [successFlg, setSuccessFlg] = useState(false);

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        setGolfLocation("");
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onClickCheckInput = (reserve, target) => {
        let date = reserveCheckInfo.playDate.substr(0, 10);
        let planId = parseInt(reserveCheckInfo.ttbPlanID)
        if (target == "change") {
            addTeeTimeList([]);
            changeReserveNo(reserveCheckInfo.reservationNo);
            common.doPost("/reserve/api/golf/requestGolfDetail", { planidStr: reserveCheckInfo.ttbPlanID, playDate: date, days: 1 }, afterDetailConditionApi);
        } else if (target == "cancel") {

            // 予約のキャンセル実行
            onClickOpenCancelPopupWindow();
            console.log(golfReservationCancel);
            // let flg = "0";
            // if(reserveCheckInfo.planName === "１人予約" ||  reserveCheckInfo.planName === "キャンセル待ち予約"){
            //     flg = "1"
            // }
            // common.doPost("/reserve/api/golf/requestGolfCancel", { reservationNo: reserve.reservationNo,requestFlg:flg}, afterCancelReservation);
        }
    }

    //利用者情報変更押下時
    const onClickChangePlayer = () => {
        //reduxのplanにプラン情報を詰め込み
        let date = reserveCheckInfo.playDate.substr(0, 10);
        changeReserveNo(reserveCheckInfo.reservationNo);
        common.doPost("/reserve/api/golf/requestGolfDetail", { planidStr: reserveCheckInfo.ttbPlanID, playDate: date, days: 1 }, afterDetailConditionChangePlayer);
    }

    const afterDetailConditionApi = (res) => {
        if (res.data.resultCode === 0) {
            setPlanTimeInfo(res.data.planData);
            setReserveType("real");
            history.push("/reserve/golf/changeStartTime");
        } else {
            //　★TODO　エラー処理を記載する
        }
    }

    const afterDetailConditionChangePlayer = (res) => {
        if (res.data.resultCode === 0) {
            //プラン情報を取得
            let planCnvDate = setPlanTimeInfo(res.data.planData);
            //プラン情報からコース情報取得
            let courseInfo = getCourseInfo(planCnvDate);
            //コース情報を用いてInputPlayer TeetimeListに情報の格納
            setPlayerAndTeetime(courseInfo);
            setReserveType("real");
            history.push("/reserve/golf/userInput");
            setGolfLocation("input");
        } else {
            //　★TODO　エラー処理を記載する
        }
    }

    //予約者情報と枠情報の格納
    const setPlayerAndTeetime = (course) => {
        const tempList = course.map((data) => {
            return {
                teeTime: data.teetime,
                courseID: data.courseID,
                courseName:data.courseName,
                playerCount: data.playerCount,
                playerList: [],
                planSetId: data.plansetID,
                price: data.priceTotal,
                discount: data.discount,
                referralPrice: "",
                priceVisitorAccompany: "",
                additionalFee2b: "",
                additionalFee3b: "",
                usageFeeType: data.usageFeeType,
                usageFee: data.usageFee,
                usageFeeRate: "",
                maxUsageFee: "",
            }
        });

        const teeTimeList = tempList.filter((data) => {
            return data.playerCount !== 0;
        });

        //バリデーションチェック
        let flg = false;
        // 時間情報がない場合は次画面遷移しない
        if (teeTimeList.length === 0){
            flg = true;
        }
        
        if(reserveCheckInfo !== undefined && reserveCheckInfo !== null && reserveCheckInfo.length !== 0){
            let playerSumList = [];
            //予約情報を選択された時間とコースIDで絞る
            teeTimeList.map((data) => {
                let reserveTeeTime = reserveCheckInfo.teeTimeList.filter((reserve, idx)=>{
                    let hour = reserve.teeTime.substr(0,2);
                    let minite = reserve.teeTime.substr(2,4);
                    let time = hour+':'+minite;
                    return data.teeTime === time && data.courseID.toString() === reserve.courseID;
                })
                //予約情報を自動入力
                let playerList = [];
                for(let i = 0; i < data.playerCount; i++){
                    // let flg = true;
                    //自動入力できる箇所がある場合
                    if(i === 0){
                        reserveTeeTime.map((reserveData) => {
                            reserveData.playerList.map((player) => {
                                let undecided = false;
                                if(player.playerName === "未記入"){
                                    undecided = true;
                                }
                                let name = player.playerName.split(" ");
                                let nameKana = player.playerNameKana.split(" ");
                                let representFlg = false;
                                if(player.webUserFlag === 1){
                                    representFlg = true;
                                }
                                const inputPlayerInfo = {
                                    courseId:reserveData.golfCourseID,
                                    familyName: undecided ? "" : name[0],
                                    name: undecided ? "" : name[1],
                                    familyNameKana: undecided ? "" : nameKana[0],
                                    nameKana: undecided ? "" : nameKana[1],
                                    undecided: undecided,
                                    represent: representFlg,
                                    gender: player.genderType.toString(),
                                }
                                // flg = false;
                                playerList.push(inputPlayerInfo);
                            })
                        })
                    }
                    //自動入力できる箇所がない場合は初期値
                    if(playerList.length < data.playerCount){
                        const brunkObj = {
                            courseId:"",
                            familyName: "",
                            name: "",
                            familyNameKana: "",
                            nameKana: "",
                            undecided: "",
                            represent: "",
                            gender: "0",
                        }
                        playerList.push(brunkObj);
                    }
                }
                playerSumList.push(playerList);
            })
            addInputPlayer(playerSumList);
        }
        if(flg){
            return;
        }
        // 枠情報
        addTeeTimeList(teeTimeList);
    }

    //コース情報取得
    const getCourseInfo = (planCnvDate) => {
        const plansets = planCnvDate.plansets;
        let courseList = [];
        let teeTimeList = [];
        
        let timeList = [];
            plansets.forEach((plan) => {
                plan.playdates.forEach((playdate) => {
                    playdate.courses.forEach((course) => {
                        course.teetimes.forEach((teetime) => {
                            if(teetime.count !== undefined){
                                let autoPlayer = {
                                    teeTime: teetime.teetime,
                                    courseID: course.courseID,
                                    courseName:course.courseName,
                                    playerCount: teetime.count,
                                }
                                timeList.push(autoPlayer);
                            }
                        })
                    })
                })
            })
            if(timeList.length !== 0){
                teeTimeList = timeList;
            }

        if(plansets === undefined){
            return;
        }
        for (let i = 0; i < plansets.length; i++) {
            let plansetID = plansets[i].plansetID;
            let priceTotal = plansets[i].priceTotal;
            let playdates = plansets[i].playdates;

            for (let j = 0; j < playdates.length; j++) {
                let courses = playdates[j].courses;

                for (let k = 0; k < courses.length; k++) {
                    let courseID = courses[k].courseID;
                    let courseName = courses[k].courseName;

                    courses[k].teetimes.forEach((value) => {
                        let teetime = value.teetime;
                        if (teetime.charAt(1) === ":") {
                            teetime = `0${teetime}`;
                        }
                        const filtered = teeTimeList.filter((data) => {return (teetime === data.teeTime && courseName === data.courseName)});
                        const playerCount = filtered.length ? filtered[0].playerCount : 0;
                        const planObject = {
                            plansetID: plansetID,
                            priceTotal: priceTotal,
                            courseID: courseID,
                            courseName: courseName,
                            teetime: teetime,
                            discount: value.discount,
                            usageFeeType: "",
                            usageFee: value.usageFee,
                            playerCount: playerCount,
                        }
                        courseList = [...courseList, planObject];
                    });
                }
            }
        }
        // teetimeによるソート処理
        courseList.sort((data1, data2) => {
            let teetime1 = data1.teetime;
            let teetime2 = data2.teetime;
            teetime1 = Date.parse(`2000/01/01 ${teetime1}`);
            teetime2 = Date.parse(`2000/01/01 ${teetime2}`);
            return teetime1 - teetime2
        });
        return courseList;
    }


    const setPlanTimeInfo = (res) => {
        //予約したスタート時間をリストに格納
        let reserveTimeList = getReserveTeeTime();
        // プランの内容にrealが設定されているか,コースが存在するかチェック
        let planChkObj = getSearchPlanChk(res,reserveTimeList);
        let reqPlnCheck = planChkObj.reqPlnCheck;
        let planCourseCnt = planChkObj.planCourseCnt;
        const convCourseCheckList = planChkObj.convCourseCheckList;
        console.log("予約確認情報とプラン検索情報の一致コース：" + convCourseCheckList);

        //コース名のリスト格納＋予約済みの時間がない場合はteetimeに追加
        let courseNames = [];
        if (res.plansets === undefined || res.plansets === null || res.plansets.length === 0) {     
            let resvPlansets = [];
            // プランが取得できなかった場合
            if (reserveCheckInfo.length !== 0 && reserveCheckInfo !== undefined && reserveCheckInfo !== null) {
                let resvChkTeetimeList = reserveCheckInfo.teeTimeList;
                let playDates = [];
                let playdate = "";
                reserveCheckInfo.teeTimeList.forEach((resvPlayDate) => {
                    // プレー日が前回の日付と合っていない場合設定
                    if (playdate !== resvPlayDate.playDate) {
                        console.log('resvPlaydate');
                        playdate = resvPlayDate.playDate;
                        let resvCourseID = "";
                        let courses = [];
                        reserveCheckInfo.teeTimeList.forEach((resvCourse) => {
                            // プレー日内のコースIDが不一致の場合
                            if (playdate === resvCourse.playDate && 
                                    resvCourseID !== resvCourse.courseID)  {
                                console.log('resvCourseId');
                                let teetimes = [];
                                resvCourseID = resvCourse.courseID;
                                reserveCheckInfo.teeTimeList.forEach((resvTeetime) => {
                                    // プレー日コース名が一致する場合
                                    if (playdate === resvTeetime.playDate && 
                                        resvCourseID === resvTeetime.courseID)  {
                                            console.log('createTeeTime');
                                        let teetime = {
                                            teetime: resvTeetime.teeTime.substr(0, 2) + ':' + resvTeetime.teeTime.substr(2, 2) + ':00',
                                            type: 'real',
                                            usageFee: resvTeetime.usageFee.split('.')[0],
                                            discount: resvTeetime.discount.split('.')[0],
                                            count: resvTeetime.playerCount,
                                        }
                                        teetimes.push(teetime);
                                    }
                                })
                                let course = {
                                    courseID: resvCourse.courseID,
                                    courseName: resvCourse.courseName,
                                    teetimes: teetimes,
                                }
                                courses.push(course);
                            }
                        })
                        let playDate = {
                            playdate: playdate,
                            courses: courses,
                        }
                        playDates.push(playDate);
                    }
                })

                let createPlan = {
                    plansetID: resvChkTeetimeList[0].planSetId,
                    priceTotal: resvChkTeetimeList[0].price,
                    playdates: playDates
                };
                resvPlansets.push(createPlan);
                
                console.log('変更修正対応実施');
                res.plansets = resvPlansets;
            }
        } else if (reqPlnCheck === 0 || planCourseCnt !== convCourseCheckList.length) {
            // プランが取得できなかった場合
            if (reserveCheckInfo.length !== 0 && reserveCheckInfo !== undefined && reserveCheckInfo !== null) {
                reserveCheckInfo.teeTimeList.forEach((resvTeeTime) => {
                    let setTeeTime = {
                        teetime: resvTeeTime.teeTime.substr(0, 2) + ':' + resvTeeTime.teeTime.substr(2, 2) + ':00',
                        type: 'real',
                        usageFee: resvTeeTime.usageFee.split('.')[0],
                        discount: resvTeeTime.discount.split('.')[0],
                        count: resvTeeTime.playerCount,
                    }
                    let teeTimeSetChk = 0;
                    res.plansets.forEach((apiPlan, pidx) => {
                        if (apiPlan.plansetID == Number(resvTeeTime.planSetId)) {
                            apiPlan.playdates.forEach((apiPlayDate, pldIdx) => {
                                if (apiPlayDate.playdate === resvTeeTime.playDate) {
                                    console.log('resvPlaydate');
                                    let courseSetCheck = 0;
                                    apiPlayDate.courses.forEach((apiCourse, crsIdx) => {
                                        if (apiCourse.courseID == Number(resvTeeTime.courseID)) {
                                            console.log('TeeTime追加');
                                            res.plansets[pidx].playdates[pldIdx].courses[crsIdx].teetimes.push(setTeeTime);
                                            courseSetCheck = 1;
                                            teeTimeSetChk = 1;
                                        }
                                    })
                                    // 新規コース追加
                                    if (courseSetCheck === 0) {
                                        console.log('コース追加');
                                        let setTeeTimes = [];
                                        setTeeTimes.push(setTeeTime);
                                        let setCourse = {
                                            courseID: resvTeeTime.courseID,
                                            courseName: resvTeeTime.courseName,
                                            teetimes: setTeeTimes,
                                        }
                                        res.plansets[pidx].playdates[pldIdx].courses.push(setCourse);
                                        teeTimeSetChk = 1;
                                    }
                                }
                            })
                        }
                    })
                    
                    if (teeTimeSetChk === 0) {
                        // TeeTimes作成
                        let addTeeTimes = [];
                        addTeeTimes.push(setTeeTime);
                        // Course作成
                        let addCourse = {
                            courseID: Number(resvTeeTime.courseID),
                            courseName: resvTeeTime.courseName,
                            teetimes: addTeeTimes,
                        };
                        let addCourses = [];
                        addCourses.push(addCourse);
                        // playdate作成
                        let addPlayDate = {
                            playdate: resvTeeTime.playDate,
                            courses: addCourses,
                        };
                        let addPlayDates = [];
                        addPlayDates.push(addPlayDate);
                        // planset作成
                        let addPlanset = {
                            plansetID: Number(resvTeeTime.planSetId),
                            priceTotal: Number(resvTeeTime.price),
                            playdates: addPlayDates,
                        };
                        // プラン追加
                        res.plansets.push(addPlanset);
                    }
                })
            }
        }

        if (res.plansets !== undefined && res.plansets.length !== 0) {
            res.plansets.forEach((planset) => {
                let playdates = planset.playdates
                playdates.forEach((playdate) => {
                    let courses = playdate.courses;
                    let pops = [];
                    courses.forEach((course, idx) => {
                        const teetimes = course.teetimes;
                        teetimes.forEach((time) => {
                            time.teetime = time.teetime.substr(0, 5);
                        })
                        course.teetimes = teetimes.filter((teetime) => {
                            return teetime.type === "real";
                        })
                        if (course.teetimes.length === 0) {
                            pops.push(idx);
                        }
                        else if (!courseNames.includes(course.courseName)) {
                            courseNames.push(course.courseName);
                        }

                        reserveTimeList.forEach((reserveTeeTime) => {
                            let flg = false;
                            if (flg) { return }
                            teetimes.forEach((teeTime) => {
                                if (teeTime.teetime === reserveTeeTime.teetime) {
                                    flg = true;
                                }
                            })
                            if (flg) {
                                reserveTeeTime.flg = false;
                            }
                        })
                    })
                    courses = courses.filter((course, idx) => {
                        return !pops.includes(idx);
                    })
                    playdate.courses = courses;
                })
                planset.playdates = playdates.filter((course, idx) => {
                    return !course.courses.length == 0;
                })
            })
            setCourseNames(courseNames);

            //teetimeの値を変更
            res.plansets.forEach((planset) => {
                let playdates = planset.playdates
                playdates.forEach((playdate) => {
                    let courses = playdate.courses;
                    let pops = [];
                    courses.forEach((course, idx) => {
                        reserveTimeList.forEach((reserveTeeTime) => {
                            let flg = true;
                            if (course.courseID.toString() === reserveTeeTime.courseId) {
                                //人数を設定して再格納（人数自動入力機能）
                                if (!reserveTeeTime.flg) {
                                    course.teetimes.forEach((teeTime) => {
                                        // コースの時間が存在する場合は人数自動入力
                                        if (teeTime.teetime === reserveTeeTime.teetime) {
                                            flg = false;
                                            let obj = {
                                                teetime: course.teetime,
                                                type: 'real',
                                                count: reserveTeeTime.count,
                                                usageFee: course.usageFee,
                                                discount: course.discount,
                                            }
                                            teeTime = obj;
                                        }
                                    })
                                    if (flg) {
                                        course.teetimes.push(reserveTeeTime);
                                    }
                                }
                                //プラン詳細取得でユーザが予約した日がない場合は時間を追加する
                                if (reserveTeeTime.flg) {
                                    flg = true;
                                    course.teetimes.push(reserveTeeTime);
                                }
                            }
                        })
                    })
                    courses = courses.filter((course, idx) => {
                        return !pops.includes(idx);
                    })
                    playdate.courses = courses;
                })
                planset.playdates = playdates.filter((course, idx) => {
                    return !course.courses.length == 0;
                })
            })
            setPlan(res);
            return res;
        }
    }

    const getReserveTeeTime = () => {
        let reserveTimeList = [];
        //予約したスタート時間をリストに格納
        reserveCheckInfo.teeTimeList.forEach((teeTime) => {
            let hour = teeTime.teeTime.substr(0, 2);
            let minite = teeTime.teeTime.substr(2, 4);
            let time = hour + ':' + minite;
            let timeObj = {
                teetime: time,
                count: teeTime.playerCount,
                usageFee: teeTime.usageFee,
                discount: teeTime.discount,
                courseName: teeTime.courseName,
                courseId: teeTime.courseID,
                type: 'real',
                flg: true,
            }
            reserveTimeList.push(timeObj);
        })
        return reserveTimeList;
    }

    // プランの内容にrealが設定されているかチェック、一致コースの取得
    const getSearchPlanChk = (res,reserveTimeList) => {
        let reqPlnCheck = 0;
        let planCourseCnt = 0;
        let courseCheckList = [];
        if (res.plansets !== undefined && res.plansets !== null && res.plansets.length !== 0) {
            res.plansets.forEach((planset) => {
                let playdates = planset.playdates
                playdates.forEach((playdate) => {
                    let courses = playdate.courses;
                    planCourseCnt = courses.length;
                    courses.forEach((course) => {
                        //予約を取ったコースが現在空き枠があるかチェック
                        reserveTimeList.map((reserveCourse) => {
                            if(reserveCourse.courseId === course.courseID.toString()){
                                courseCheckList.push(reserveCourse.courseId);
                            }
                        })
                        let teetimes = course.teetimes;
                        teetimes.forEach((time) => {
                            if(time.type === "real") {
                                reqPlnCheck = 1;
                            }
                        })
                    })
                })
            })
        }
        const convCourseCheckList = Array.from(new Set(courseCheckList))
        let retObj = {
            reqPlnCheck:reqPlnCheck,
            planCourseCnt:planCourseCnt,
            convCourseCheckList:convCourseCheckList,
        }
        return retObj;
    }


    const afterCancelReservation = (res) => {
        // キャンセル後のリスト更新等必要な処理を実施する。
        console.log("キャンセル処理");
        if (res.data.resultCode === 0) {
            //キャンセル成功画面へ遷移
            history.push("/reserve/golf/cancel");

        } else {
            setSuccessFlg(true);
        }
    }

    // 予約情報取得後処理
    const afterConfirmHotelReservation = (res) => {
        const data = res.data;
        if (data.resultCode != 0) {
            setReserveInfo({});
        } else {
            let reserveInfo = data.reserve.find(v => v.reserveId == toUserInputInfo.searchReserveId);
            setToUserInputInfo({ ...toUserInputInfo, searchReserveId: null })
            setReserveInfo(reserveInfo);
        }
    }

    const dateForm = (res) => {
        let date = res.substr(0, 4) + "年";
        if (res.substr(5, 1) === '0') {
            date = date + res.substr(6, 1) + "月";
        } else {
            date = date + res.substr(5, 2) + "月";
        }

        if (res.substr(8, 1) === '0') {
            date = date + res.substr(9, 1) + "日";
        } else {
            date = date + res.substr(8, 2) + "日";
        }

        return date;
    }

    const timeForm = (res) => {
        let time = "";
        if (res.substr(0, 1) === '0') {
            time = res.substr(1, 1);
        } else {
            time = res.substr(0, 2);
        }
        time = time + "時";

        if (res.substr(2, 1) === '0') {
            time = time + res.substr(3, 1);
        } else {
            time = time + res.substr(2, 2);
        }
        time = time + "分";
        return time;
    }

    const playerConvert = (name ,kanaName) => {
        if(name === "未記入"){
            return "未定";
        }else if(name && kanaName){
            return name + "(" + kanaName + ") 様";
        }else if(name && !kanaName){
            return name + " 様";
        }else{
            return kanaName + " 様";
        }
    }
    return (
        <>
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={"/reserve/golf/search"} style={styles.pan} >ゴルフ予約</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="予約詳細確認" style={styles.pan} />
            </div>
            <div className="userInputInnerWrapper">
                <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
                <div className="reserveGolfConirmWrapper">
                    {/* {successFlg ?
                        <div style={{ textAlign: "center", color: "red", paddingTop: 20, fontSize: 13 }}>お手数ですが予約されているゴルフ場までお問い合わせください。</div>
                        : null} */}
                    <div className="reserveContentWrapper">
                        <Label label="ご予約内容" className="reserveConirmTitle2" />
                        <div className="reservationGolfContentsWrap">
                            <div className="reservationGolfReserveContents">
                                <Label
                                    label="プレー日"
                                    className="inputGolfConfirlTitleLabel"
                                />
                                <Label
                                    label={commonUtil.getStringFromDateJpnGolf(reserveCheckInfo.playDate.substr(0, 10))}
                                    className="inputContentLabel"
                                />
                            </div>
                            <div className="reservationGolfReserveContents">
                                <Label
                                    label="ゴルフ場"
                                    className="inputGolfConfirlTitleLabel"
                                />
                                <Label
                                    label={reserveCheckInfo.golfCourseName}
                                    className="inputContentLabel"
                                />
                            </div>
                            <div className="reservationGolfReserveContents">
                                <Label
                                    label="お問合せ番号"
                                    className="inputGolfConfirlTitleLabel"
                                />
                                <Label
                                    label={reserveCheckInfo.reservationNo}
                                    className="inputContentLabel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {reserveCheckInfo.isRequest === "true" ?
                    null
                    :
                    <div className="reserveConirmWrapper">
                        <div className="reserveContentWrapper">
                            <Label label="プレー情報" className="reserveConirmTitle2" />
                            <div style={isWideTablet ? styles.mopDivSp : styles.mapDiv}>
                                {reserveCheckInfo.teeTimeList ? reserveCheckInfo.teeTimeList.map((round, roundIndex) => {
                                    return <div><div className="reservationGolfContentsWrapGroup">
                                        <div className="reservationGolfReserveContents">
                                            <Label
                                                label={(roundIndex + 1) + "組目"}
                                                className="inputGolfConfirlGroupLabel"
                                            />
                                        </div>
                                        <div className="reservationGolfReserveContents">
                                            <Label
                                                label="コース名"
                                                className="inputGolfConfirlTitleLabel"
                                            />
                                            <Label
                                                label={round.courseName}
                                                className="inputContentLabel"
                                            />
                                        </div>
                                        <div className="reservationGolfReserveContents">
                                            <Label
                                                label="スタート時間"
                                                className="inputGolfConfirlTitleLabel"
                                            />
                                            <Label
                                                label={timeForm(round.teeTime)}
                                                className="inputContentLabel"
                                            />
                                        </div>
                                        <div className="reservationGolfReserveContentsPlayer">
                                            <Label
                                                label="名前"
                                                className="inputGolfConfirlTitleLabel"
                                            />
                                            <div className="golfConfirmPlayerName">
                                                {round.playerList ? round.playerList.map((player, playerIndex) => {
                                                    return <Label
                                                        label={playerConvert(player.playerName,player.playerNameKana)}
                                                        className="inputContentLabel"
                                                    />
                                                })
                                                : 
                                                null}
                                            </div>
                                        </div>
                                    </div></div>
                                }) : null}
                            </div>
                        </div>
                    </div>
                }
                <div className={"btnToBookingBoderWrapper"}>
                    <div className="bookingGolfboxWrap">
                        <div className="golfCofirmBtnArea">
                            {reserveCheckInfo.planName === "１人予約" ||  reserveCheckInfo.planName === "キャンセル待ち予約" ?
                                null
                                :
                                <div>
                                    <div className="golfConfirmBtnLeft">
                                        <Button buttonText="人数・スタート時間変更" className="btnDispGolfReserveConfirm" onClick={() => onClickCheckInput(reserveCheckInfo, "change")} buttonClassName="serachBtnText" />
                                    </div>
                                    <div className="golfConfirmBtnRight">
                                        <Button buttonText="利用者情報変更" className="btnDispGolfReserveConfirm" onClick={onClickChangePlayer} buttonClassName="serachBtnText" />
                                    </div>
                                </div>
                            }
                            <div className="golfConfirmCancelBtnArea">
                                <Button buttonText="予約をキャンセル" className="btnCancelGolfReserveConfirm" onClick={() => onClickCheckInput(reserveCheckInfo, "cancel")} buttonClassName="btnCancelConfirmText" />
                            </div>
                        </div>
                    </div>
                    <div className="bookingbackTop">

                    </div>
                </div>
                <div style={isWideTablet ? styles.footer2 : styles.footer}>
                    <GolfFooterContainer />
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        reserveCheckInfo: state.reserveCheckInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setReserveGolfCancelInfo: (item) => {
            dispatch({ type: "RESERVE_GOLF_CANCEL_INFO", payload: { reserveGolfCancelInfo: item } })
        },
        setPlan: (item) => {
            dispatch({ type: "SET_PLAN", payload: { plan: item } })
        },
        setCourseNames: (item) => {
            dispatch({ type: "SET_COURSE_NAMES", payload: { courseNames: item } })
        },
        setReserveType: (item) => {
            dispatch({ type: "RESERVE_TYPE", payload: { reserveType: item } })
        },
        changeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        addInputPlayer: (item) => {
            dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: item} })
        },
        setGolfLocation: (item) => {
            dispatch({ type: "GOLF_LOCATION", payload: { golfLocation: item} })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfBookingConfirmContainer);


const styles = {
    mapDiv: {
        width: "79%",
    },
    mapDiv: {
        width: "100%",
    },
    firstRoomWrapper: {
        width: "80%",
        margin: "0px auto",
        backgroundColor: "#808080",
        padding: "10px 10% 10px 10%",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    roomNum: {
        display: "flex",
        padding: "20px 0px 20px 0px",
        marginBottom: "20px",
        justifyContent: "space-between",
        borderBottom: "1px solid #bfbec5",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLinkArea: {
        marginTop: "30px",
        paddingTop: "40px",
        textAlign: "center",
        borderTop: "1px solid #bfbec5",
    },
    bottomLink: {
        padding: "3px",
        color: "black",
        fontSize: "small",
    },
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
    },
    genderWrap: {
        marginBottom: "20px",
    },
    gender: {
        display: "flex",
    },
    genderLabel: {
        margin: "0px 30px 0px 10px",
    },
    confirmbox: {
        width: "100%",
        display: "flex",
        borderTop: "1px solid rgb(191, 190, 197)",
        borderBotttom: "1px solid rgb(191, 190, 197)",
        padding: "30px 0px",
    },
    paymentOption: {
        display: "flex",
        marginTop: "20px",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        paddingLeft: "20%",
        marginBottom: "50px",
        width: "100%",
        paddingTop: "50px",
        boxSizing:"border-box"
    },
    breadCrumb2: {
        visibility: "hidden",
        height: "10px"
    },
    fee: {
        display: "flex",
        justifyContent: "space-between",
    },
    pullDownArea: {
        display: "flex",
        alignItems: "center"
    },
    reservationInfo: {
        display: "flex",
        justifyContent: "space-between",
        margin: "20px 60px 20px 100px",
    }
}
